// src/hooks/useBranding.ts

import { useLayoutEffect, useState } from 'react';

import { brandingMap, BrandingInfo } from '../config/brandingMap';

// Branding sofort berechnen (außerhalb der Komponente)
const getBrandingForHostname = (): BrandingInfo => {
  if (typeof window === 'undefined') {
    // Fallback für SSR
    return brandingMap['localhost'];
  }
  
  const hostname = window.location.hostname;
  return brandingMap[hostname] || brandingMap['localhost'];
};

// Globale Variable um doppelte Setzungen zu vermeiden
let currentFaviconUrl = '';

export const useBranding = (): BrandingInfo => {
  // Branding sofort mit dem korrekten Wert initialisieren
  const [branding] = useState<BrandingInfo>(() => getBrandingForHostname());

  // useLayoutEffect läuft vor dem Paint - verhindert Flackern
  useLayoutEffect(() => {
    // Nur setzen wenn sich wirklich was geändert hat
    if (currentFaviconUrl === branding.faviconUrl && document.title === branding.appName) {
      return;
    }

    // Titel setzen
    document.title = branding.appName;

    // Favicon aggressiv setzen
    const setFaviconRobust = (href: string) => {
      console.log('🔧 Setting favicon to:', href);
      
      // Alle bestehenden Favicon-Links sofort entfernen
      const allIcons = document.querySelectorAll('link[rel*="icon"]');
      console.log('🗑️ Removing', allIcons.length, 'existing icons');
      allIcons.forEach(icon => icon.remove());

      // Mehrere Favicon-Formate hinzufügen für maximale Kompatibilität
      const iconTypes = [
        { rel: 'icon', type: 'image/x-icon' },
        { rel: 'shortcut icon', type: 'image/x-icon' },
        { rel: 'icon', type: 'image/png' }
      ];

      iconTypes.forEach(iconType => {
        const link = document.createElement('link');
        link.rel = iconType.rel;
        link.type = iconType.type;
        link.href = href + '?v=' + Date.now(); // Cache-Busting
        document.head.appendChild(link);
        console.log('✅ Added favicon:', iconType.rel, link.href);
      });

      currentFaviconUrl = href;
      console.log('✨ Favicon setting complete');
    };

    setFaviconRobust(branding.faviconUrl);
  }, [branding.appName, branding.faviconUrl]);

  return branding;
};


